import store from "@/store";
import bundleApi from "./bundle.api";
import Logger from "@/helpers/logger";

class BundleService {
  async getBundleList() {
    try {
      const data = await bundleApi.getBundleList();
      store.dispatch("bundle/bundleList", data.bundleDetails || []);
      return data;
    } catch (e) {
      Logger.error("`getBundleList` service", e);
      return Promise.reject(e);
    }
  }
}

const bundleService = new BundleService();

export default bundleService;
